<div class="quill-editor-container">
  <div #editorContainer class="editor-container"></div>
</div>

@if (showHtmlSourceModal) {
  <div class="html-source-overlay" (click)="cancelHtmlSource()">
    <div class="html-source-dialog" (click)="$event.stopPropagation()">
      <div class="html-source-header">
        <span>HTML Source Editor</span>
        <button type="button" class="html-source-close" (click)="cancelHtmlSource()">&times;</button>
      </div>
      <textarea class="html-source-textarea" [(ngModel)]="htmlSourceContent" [ngModelOptions]="{standalone: true}"></textarea>
      <div class="html-source-footer">
        <button type="button" class="html-source-btn html-source-btn-cancel" (click)="cancelHtmlSource()">Cancel</button>
        <button type="button" class="html-source-btn html-source-btn-update" (click)="applyHtmlSource()">Update</button>
      </div>
    </div>
  </div>
}
